import React from "react";
import { TabControler } from "component/TabControler/TabControler";
import Back from "component/back/Back";
import { Input } from "component/inputs/Input";
import { Field, Form } from "react-final-form";
import { PagesPreliquidationTypes } from "../types";
import "./detailPreliquidation.scss";
import { DetailPreliquidationPropsType } from "./types";
import { BasicIcon, StatusStepper } from "@pickit/pickit-components";
import { Transactions } from "./transactions/Transactions";
import { ISO8601toDDMMYYYHHMM } from "utils/date";
import "./i18n";
import { useTranslation } from "react-i18next";
import { PreliHistoryType } from "reducers/types/preliquidation";
import { PRELIQUIDATION_STATUS } from "utils/constants";

export const DetailPreliquidation = ({
  preliquidation,
  actualPage,
  initialValues,
  tabs,
  changePage,
  handleClickBack,
  toggleModalVisibility,
  testId,
}: DetailPreliquidationPropsType) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="header-container">
        <TabControler<PagesPreliquidationTypes>
          tabs={tabs}
          changePage={changePage}
          actualPage={actualPage}
          clickable={false}
        />
        <Back
          testId={`${testId}-button-back`}
          id="preliquidation-button-back"
          onClick={handleClickBack}
        />
      </div>
      <div className="detail-preliquidation-number-container">
        <h2
          data-testId={`${testId}-presettlement-number-title`}
          className="detail-preliquidation-h2"
        >
          {t("detailPresettlement:presettlementNumber")}
        </h2>
        <p
          data-testId={`${testId}-presettlement-number`}
          className="detail-preliquidation-number"
        >
          {preliquidation?.id}
        </p>
      </div>
      <Form onSubmit={(value) => value} initialValues={initialValues}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="display-filter detail-preliquidation">
              <div className="container-detail-preliquidation-form-row">
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    name="status"
                    label={t("presettlement:status")}
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-status`}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    label={t("presettlement:emisionDate")}
                    name="emisionDate"
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-emision-date`}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    name="fiscalNumber"
                    label={t("presettlement:fiscalNumber")}
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-fiscal-number`}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    label={t("presettlement:companyName")}
                    name="companyName"
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-company-name`}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    name="sapCode"
                    label={t("presettlement:sapCode")}
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-sap-code`}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    type="text"
                    name="region"
                    label={t("presettlement:region")}
                    component={Input}
                    className="Admin-Pickers-input"
                    language="es"
                    disabled={true}
                    testId={`${testId}-field-region`}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </Form>
      <div className="detail-preliquidation-container-card">
        <div className="container-detail-preliquidation-card-row">
          <div className="container-detail-preliquidation-card-col-sm-5 container-detail-preliquidation-card-col-xl-4">
            <h2 data-testId={`${testId}-history-title`}>
              {t("presettlement:history")}
            </h2>
            <div className="display-card-preliquidation relative">
              <div className="preliquidation-history-container">
                <StatusStepper
                  width="100%"
                  status={preliquidation.histories.map(
                    (state: PreliHistoryType) => {
                      return {
                        status: "success",
                        title: state.title,
                        subtitle: ISO8601toDDMMYYYHHMM(state.createdAt),
                        content: state.description,
                      };
                    }
                  )}
                  testId={testId}
                />
              </div>
              <div className="history-footer-transparent" />
            </div>
          </div>
          <div className="container-detail-preliquidation-card-col-sm-7 container-detail-preliquidation-card-col-xl-5">
            <div className="preliquidation-transactions-header">
              <h2 data-testId={`${testId}-transactions-title`}>
                {t("presettlement:trips")}
              </h2>
              <button
                data-testId={`${testId}-button-change-amount`}
                disabled={preliquidation.status !== PRELIQUIDATION_STATUS.INITIAL}
                className="button-change-amount"
                onClick={() => {
                  toggleModalVisibility(true);
                }}
              >
                <BasicIcon
                  color={
                    preliquidation.status !== PRELIQUIDATION_STATUS.INITIAL ? "#CCC" : "#0098ff"
                  }
                  name={"pencil-alt"}
                />
                <p>{t("presettlement:changeAmount")}</p>
              </button>
            </div>
            <div className="display-card-preliquidation">
              <Transactions
                total={preliquidation.total}
                trips={preliquidation.trips}
                adjustments={preliquidation.adjustments}
                testId={testId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
